import { Loading } from "@app/components";
import { useInstallation, useUser } from "@services/servicesGenericsTables";
import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";

export default function LayoutEditTransitDoses() {
  const [loading, setLoading] = useState<boolean>(true);

  const { fetchAll: fetchAllUser } = useUser();
  const { fetchAll: fetchAllInstallation } = useInstallation();

  useEffect(() => {
    const fetchData = async () => {
      try {
        await Promise.all([fetchAllUser(), fetchAllInstallation()]);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return loading ? <Loading /> : <Outlet />;
}
